// RudraFeedTab — lifted verbatim out of LiveTrading.tsx (God 2026-08-26).
// Same code, smaller address: a UI problem in this panel is now a 82-line file
// to read instead of a 6,900-line one. Imports are derived from what the block
// actually references, not guessed.

import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { API_BASE_URL } from './foundation';

export const RudraFeedTab: React.FC<{
  tab: 'SCALPING' | 'CASH' | 'FUTURES' | 'OPTION';
  onDeploy: (card: any) => void;
  onChart: (sym: string) => void;
  wide?: boolean;
}> = ({ tab, onDeploy, onChart, wide }) => {
  const [cards, setCards] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    const load = () => fetch(`${API_BASE_URL}/ceo-feed?tab=${tab}&t=${Date.now()}`)
      .then(r => r.json())
      .then(j => { if (alive) { setCards(j.status === 'success' ? (j.signals || []) : []); setLoading(false); } })
      .catch(() => { if (alive) setLoading(false); });
    setLoading(true); load();
    // 🔁 hidden-pause — CEO feed cards display-only
    const iv = setInterval(() => { if (!document.hidden) load(); }, 30000);
    return () => { alive = false; clearInterval(iv); };
  }, [tab]);
  if (loading && !cards.length) return <div style={{ textAlign: 'center', padding: 36, color: '#475569', fontSize: 11 }}>⏳ {tab} signals scan ho rahe…</div>;
  if (!cards.length) return <div style={{ textAlign: 'center', padding: 36, color: '#475569', fontSize: 11 }}>📭 Abhi koi clear {tab} signal nahi<br/><span style={{ fontSize: 9, color: '#64748b' }}>WAIT zone — market khulte hi BUY/SELL aayenge</span></div>;

  const renderCard = (c: any, i: number) => {
    const buy = c.signal === 'BUY';
    const col = buy ? '#10b981' : '#ef4444';
    return (
      <div key={`${c.symbol}-${i}`} style={{ padding: 10, marginBottom: 6, background: '#0d1117', borderRadius: 8, border: `1px solid ${col}33`, borderLeft: `3px solid ${col}` }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 11, fontWeight: 900, color: col, letterSpacing: 1 }}>{c.signal}</span>
            {c.option_leg && <span style={{ fontSize: 8, fontWeight: 900, padding: '1px 4px', borderRadius: 3, background: c.option_leg === 'CE' ? '#10b981' : '#ef4444', color: '#fff' }}>{c.option_leg}</span>}
            <span style={{ fontSize: 10, color: '#e2e8f0', fontWeight: 700 }}>{c.instrument || c.symbol}</span>
            <span style={{ fontSize: 7.5, fontWeight: 800, padding: '1px 5px', borderRadius: 3, background: 'rgba(168,85,247,.15)', color: '#c084fc' }}>{c.format} · {c.style}</span>
          </div>
          {c.confidence && <span style={{ fontSize: 8, fontWeight: 800, color: c.confidence === 'HIGH' ? '#10b981' : c.confidence === 'MEDIUM' ? '#fbbf24' : '#94a3b8' }}>{c.confidence}</span>}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, fontSize: 8.5, color: '#64748b', marginBottom: 5 }}>
          <div>📍 Spot <span style={{ color: '#fff', fontFamily: 'monospace' }}>{c.spot}</span></div>
          <div style={{ textAlign: 'right' }}>🎯 {c.entry ? `${c.entry[0]}–${c.entry[1]}` : '—'}</div>
          <div>🛑 SL <span style={{ color: '#ef4444', fontFamily: 'monospace' }}>{c.stoploss ?? '—'}</span></div>
          <div style={{ textAlign: 'right' }}>🏁 {c.t1 ?? '—'} / {c.t2 ?? '—'} {c.rr ? `· R:R 1:${c.rr}` : ''}</div>
        </div>
        {(c.notes || []).length > 0 && (
          <div style={{ fontSize: 8, color: '#94a3b8', lineHeight: 1.5, marginBottom: 6, paddingLeft: 2 }}>
            {(c.notes || []).slice(0, 3).map((n: string, k: number) => <div key={k}>• {n}</div>)}
          </div>
        )}
        <div style={{ display: 'flex', gap: 6 }}>
          <button onClick={() => onDeploy(c)} style={{ flex: 1, padding: '6px 8px', borderRadius: 6, fontSize: 9, fontWeight: 800, letterSpacing: .5, background: `linear-gradient(135deg,${col},${buy ? '#059669' : '#dc2626'})`, color: '#fff', border: 'none', cursor: 'pointer' }}>🚀 DEPLOY BOT</button>
          <button onClick={() => onChart(c.symbol)} style={{ flex: 1, padding: '6px 8px', borderRadius: 6, fontSize: 9, fontWeight: 800, letterSpacing: .5, background: '#1e293b', color: '#22d3ee', border: '1px solid #22d3ee55', cursor: 'pointer' }}>📊 SUPERCHART</button>
        </div>
      </div>
    );
  };

  // BUY/SELL alag group (Option me CE=bullish / PE=bearish se group)
  const isOption = tab === 'OPTION';
  const bullish = cards.filter((c: any) => isOption ? c.option_leg !== 'PE' : c.signal === 'BUY');
  const bearish = cards.filter((c: any) => isOption ? c.option_leg === 'PE' : c.signal === 'SELL');
  const Section: React.FC<{ list: any[]; label: string; color: string }> = ({ list, label, color }) => (
    list.length === 0 ? null : (
      <div style={{ marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 8px', marginBottom: 6, borderRadius: 6, background: `${color}14`, border: `1px solid ${color}44` }}>
          <span style={{ fontSize: 10, fontWeight: 900, color, letterSpacing: 1 }}>{label}</span>
          <span style={{ fontSize: 9, fontWeight: 800, color, background: `${color}22`, padding: '1px 7px', borderRadius: 8 }}>{list.length}</span>
        </div>
        {/* full-screen me cards multi-column grid me */}
        <div style={wide ? { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 8, alignItems: 'start' } : undefined}>
          {list.map((c, i) => renderCard(c, i))}
        </div>
      </div>
    )
  );

  return (
    <>
      <Section list={bullish} label={isOption ? '🟢 BULLISH · BUY CE' : '🟢 BUY'} color="#10b981" />
      <Section list={bearish} label={isOption ? '🔴 BEARISH · BUY PE' : '🔴 SELL'} color="#ef4444" />
    </>
  );
};

